module.exports = __webpack_public_path__ + "img/NORDIC_LOW_GLYCEMIC.18a53e89.png";